// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import {
  fetchAntennaSpecByAntennaCode,
  fetchRadioByRadioCode,
} from 'helpers/api'

import {
  getNestedByString,
  setNestedValueInObject,
} from 'helpers/reduxFormFunctions'

// NOTE - this assumes that the path database search will only async validate on the
// antennaCode and radioCode

const getPropertyCode = pathString => (
  pathString === 'radioCode'
    ? 'radioCode'
    : 'antennaCode'
)

const getPropertyId = pathString => (
  pathString === 'radioCode'
    ? 'radioId'
    : 'antennaSpecId'
)

const asyncValidate = async (formValues, f, props, pathString) => {
  // async runs one last time on submit. we don't need to do this however
  if (!pathString) {
    return
  }

  const {
    asyncErrors = {},
    change,
    dispatch,
  } = props

  const v = getNestedByString(formValues, pathString).toUpperCase()
  const hasAsyncErrors = Object.keys(asyncErrors).length

  const propertyCode = getPropertyCode(pathString)

  const propertyId = getPropertyId(pathString)

  dispatch(change(propertyId, ''))

  // this method can set values for antenna, radio and radio favorite.
  // if we're assigning values for a radio and it isn't a favorite,
  // be sure to nullify the radioFavoriteId
  const setEntity = (entity = {}) => {
    const { radioFavorite } = entity

    let entityCode = entity[propertyCode] || ''
    let radioFavoriteId = null
    const entityId = entity[propertyId] || null

    // if we're assigning a radio and that radio is actually a favorite
    if (pathString === 'radioCode' && radioFavorite) {
      entityCode = radioFavorite.favoriteRadioCode
      radioFavoriteId = radioFavorite.radioFavoriteId
    }

    dispatch(change(propertyCode, entityCode))
    dispatch(change(propertyId, entityId))

    // weither or not it was a favorite, update the radio favorite id value.
    if (pathString === 'radioCode') {
      dispatch(change('radioFavoriteId', radioFavoriteId))
    }
  }

  if (!hasAsyncErrors && !v) {
    return
  } else if (!v) {
    // even if there's no value, throw the asyncErrors object since
    // there may already be other async errors that we want to keep
    throw asyncErrors
  }

  try {
    const { entity } = await (
      pathString === 'radioCode'
        ? fetchRadioByRadioCode(v)
        : fetchAntennaSpecByAntennaCode(v)
    )
    setEntity(entity)
  } catch (err) {
    change(propertyId, null)
    setNestedValueInObject(asyncErrors, pathString, err.message)
    console.warn(err)
    throw asyncErrors
  }
  // even if everything went fine. we need to persist
  // any other async errors that might have been there.
  if (hasAsyncErrors) {
    throw asyncErrors
  }
}

export default asyncValidate
